import { useState } from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';
import { AsyncTypeahead, ClearButton, Menu, MenuItem } from 'react-bootstrap-typeahead';
import { device } from '../../../utils/styled-component-mixins';

const LocationsLandingTypeAheadStyled = styled.div`
  display: flex;
  position: relative;

  form {
    position: relative;
    width: 100%;
  }

  .rbt-aux {
    margin-right: 1.85rem;

    button {
      border: 0;
      display: flex;
      font-size: 2.6rem;
    }
  }

  .dropdown-menu {
    * {
      font-size: 1.6rem;
    }
  }

  input[type='text'] {
    border-color: var(--grey);
    display: block;
    height: 5.6rem;
    padding: 1.6rem;
    width: 100%;

    @media ${device.desktop} {
      width: 43.5rem;
    }
  }
`;

const LocationsLandingTypeAhead = (props) => {
  const { icon, searchInputLabel, onChangeFunction, typeAheadApi, id } = props;

  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleOfficeSearch = (location) => {
    const { position } = location;
    onChangeFunction(position.lat, position.lon, location);
  };

  const handleTypeAhead = (searchTerm) => {
    setIsLoading(true);
    if (searchTerm.length > 2) {
      fetch(`${typeAheadApi}${searchTerm}`)
        .then((response) => response.json())
        .then((data) => {
          setOptions(data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error(error);
          setIsLoading(false);
        });
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    const input = e.target.querySelectorAll('.rbt-input-main.form-control.rbt-input')[0].value;
    input.focus();
  };

  const handleOptionSelect = (location) => {
    handleOfficeSearch(location);
  };

  const handleOptionSelectionKeyPress = (e, optionsList) => {
    if (e.key === 'Enter') {
      const searchValue = e.target.value;
      const matchingIndex = optionsList.findIndex(
        (option) => option.address.freeformAddress === searchValue
      );

      if (matchingIndex > -1) {
        handleOptionSelect(optionsList[matchingIndex]);
      }
    }
  };

  const clearOnKeyPress = (e, onClear) => {
    if (e.key === 'Enter') {
      onClear();
    }
  };

  return (
    <LocationsLandingTypeAheadStyled icon={icon || ''}>
      <form onSubmit={handleFormSubmit} aria-label="office search">
        <AsyncTypeahead
          labelKey={(option) => option.address.freeformAddress}
          id={id}
          aria-label={searchInputLabel}
          isLoading={isLoading}
          options={options}
          placeholder={searchInputLabel}
          minLength={3}
          onKeyDown={(e) => handleOptionSelectionKeyPress(e, options)}
          onSearch={handleTypeAhead}
          renderMenu={(results, menuProps) => (
            <Menu
              aria-label={menuProps['aria-label']}
              children={menuProps.children}
              data-poppper-escaped={menuProps['data-poppper-escaped']}
              id={menuProps.id}
              innerRef={menuProps.innerRef}
              data-popper-placement={menuProps['data-popper-placement']}
              style={menuProps.style}
              data-popper-reference-hidden={menuProps['data-popper-reference-hidden']}
            >
              {results.map((result, index) => (
                <MenuItem
                  option={result}
                  position={index}
                  aria-label={result.address.freeformAddress}
                  onClick={() => handleOptionSelect(result)}
                  key={result.id}
                >
                  {result.address.freeformAddress}
                </MenuItem>
              ))}
            </Menu>
          )}
        >
          {({ onClear, selected }) => (
            <div className="rbt-aux">
              {!!selected.length && (
                <ClearButton onClick={onClear} onKeyDown={(e) => clearOnKeyPress(e, onClear)} />
              )}
              {!selected.length && <span className="material-icons">search</span>}
            </div>
          )}
        </AsyncTypeahead>
      </form>
    </LocationsLandingTypeAheadStyled>
  );
};

LocationsLandingTypeAhead.propTypes = {
  icon: propTypes.string.isRequired,
  id: propTypes.string.isRequired
};

export default LocationsLandingTypeAhead;
